const mappedUrl = {
    'articleList/articleList': 'api/article-list/v1/list',
    'main/ajax/html/deposit': 'm/ajax/html/batteriepfand',
    'bike/bikeDb': '/bike-database',
};

export default function defLouisUrl(route: string, _params: object = {}, _options: object = {}, _reUseMatchedParams: boolean = true) {
    return mappedUrl.hasOwnProperty(route) ? mappedUrl[route] : route;
}
